module.exports = __webpack_public_path__ + "img/calendar.07d7192.svg";